import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '../store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      meta: {
        fullPage: true,
        metaInfo: {
          title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
          keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
          description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
        }
      },
      component: () => import('@/pages/index/index')
    },
    {
      path: '/hotel',
      redirect: '/hotel/list',
      component: {render: (e) => e('router-view')},
      children: [
        {
          path: 'list',
          name: 'HotelList',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '酒店預定 | 港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/hotel/list')
        },
        {
          path: ':dataSource/:id',
          name: 'HotelDetail',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/hotel/detail')
        },
        {
          path: 'orderForm',
          name: 'HotelOrderForm',
          meta: {
            fullPage: false,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/hotel/orderForm')
        }
      ]
    },
    {
      path: '/ticket',
      redirect: '/ticket/list',
      component: {render: (e) => e('router-view')},
      children: [
        {
          path: 'list',
          name: 'TicketList',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/ticket/list')
        },
        {
          path: 'orderForm',
          name: 'TicketOrderForm',
          meta: {
            fullPage: false,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/ticket/orderForm')
        },
        {
          path: ':dataSource/:id',
          name: 'TicketDetail',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/ticket/detail')
        }
      ]
    },
    {
      path: '/tour',
      redirect: '/tour/list',
      component: {render: (e) => e('router-view')},
      children: [
        {
          path: 'list',
          name: 'TourList',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/tour/list')
        },
        {
          path: 'orderForm',
          name: 'TourOrderForm',
          meta: {
            fullPage: false,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/tour/orderForm')
        },
        {
          path: ':id',
          name: 'TourDetail',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/tour/detail')
        }
      ]
    },
    {
      path: '/domestic',
      component: {render: (e) => e('router-view')},
      children: [
        {
          path: 'list',
          name: 'DomesticList',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/domestic/list')
        },
        {
          path: 'orderForm',
          name: 'DomesticOrderForm',
          meta: {
            fullPage: false,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/domestic/orderForm')
        },
        {
          path: ':id',
          name: 'DomesticDetail',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/domestic/detail')
        }
      ]
    },
    {
      path: '/pay',
      component: {render: (e) => e('router-view')},
      children: [
        {
          path: ':Serial',
          name: 'PayIndex',
          meta: {
            fullPage: false,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/pay/payIndex')
        }
      ]
    },
    {
      path: '/cruise',
      component: {render: (e) => e('router-view')},
      children: [
        {
          path: 'list',
          name: 'CruiseList',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/cruise/list')
        }
      ]
    },
    {
      path: '/user',
      component: {render: (e) => e('router-view')},
      redirect: '/user/orderList/all',
      children: [
        {
          path: 'orderList/:type',
          name: 'UserOrderList',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/user/orderList')
        },
        {
          path: 'profile',
          name: 'UserProfile',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/user/profile')
        },
        {
          path: 'account',
          name: 'UserAccount',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/user/account')
        },
        {
          path: 'b2b',
          component: {render: (e) => e('router-view')},
          redirect: '/user/b2b/account',
          children: [
            {
              path: 'account',
              name: 'B2BAccount',
              meta: {
                fullPage: true,
                metaInfo: {
                  title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
                  keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
                  description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
                }
              },
              component: () => import('@/pages/user/b2b/account')
            },
            {
              path: 'quota',
              name: 'B2BQuota',
              meta: {
                fullPage: true,
                metaInfo: {
                  title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
                  keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
                  description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
                }
              },
              component: () => import('@/pages/user/b2b/quota')
            },
            {
              path: 'subAcc',
              name: 'B2BSubAcc',
              meta: {
                fullPage: true,
                metaInfo: {
                  title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
                  keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
                  description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
                }
              },
              component: () => import('@/pages/user/b2b/subAcc')
            },
            {
              path: 'profile',
              name: 'B2BProfile',
              meta: {
                fullPage: true,
                metaInfo: {
                  title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
                  keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
                  description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
                }
              },
              component: () => import('@/pages/user/b2b/profile')
            },
            {
              path: 'b2bHelper',
              name: 'B2bHelper',
              meta: {
                fullPage: true,
                metaInfo: {
                  title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
                  keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
                  description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
                }
              },
              component: () => import('@/pages/user/b2b/b2bHelper')
            }
          ]
        }
      ]
    },
    {
      path: '/article',
      component: {render: (e) => e('router-view')},
      children: [
        {
          path: ':id',
          name: 'ArticleDetail',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/article/detail')
        }
      ]
    },
    {
      path: '/specialEvent',
      component: {render: (e) => e('router-view')},
      children: [
        {
          path: 'macau',
          name: 'EventMacau',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/specialEvent/macau')
        },
        {
          path: 'chimelong',
          name: 'EventChimelong',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/specialEvent/chimelong')
        },
        {
          path: 'disney',
          name: 'EventDisney',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/specialEvent/disney')
        },
        {
          path: 'oloq',
          name: 'EventOLOQ',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/specialEvent/oloq')
        },
        {
          path: 'package/:id',
          name: 'EventPackage',
          meta: {
            fullPage: true,
            metaInfo: {
              title: '港澳酒店预订、门票线路预定 | 迪士尼、长隆门票预订 - 華逸旅遊 说走就走',
              keywords: '港澳酒店预订, 港澳门票预定, 迪士尼门票预订, 长隆门票预订, 港澳旅游线路预订, 散客港澳行程预定',
              description: '提供港澳酒店预订、门票线路预定服务，包括迪士尼和长隆门票预订。无论是同行团体还是散客，我们为您提供便捷的在线预订服务，让您畅游港澳，尽享快乐时光。'
            }
          },
          component: () => import('@/pages/specialEvent/package')
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.meta.metaInfo) {
    store.commit('CHANGE_META_INFO', to.meta.metaInfo)
  }
  next()
})

router.afterEach((to, from) => {
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js